import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CapabilitiesContainer = styled(Box)(({ theme }) => ({
  border: `0.0625rem solid ${theme.customColors.border}`,
  borderRadius: "0.5rem",
  display: "flex",
  flexDirection: "column",
  padding: "1rem",
  width: "100%"
}));

export const CapabilitiesHeader = styled(Box)(() => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  gap: "0.75rem"
}));

export const CapabilitiesIconBox = styled(Box)(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.customColors.systemSecondary01,
  borderRadius: "0.25rem",
  display: "flex",
  flexShrink: 0,
  height: "2.3125rem",
  justifyContent: "center",
  width: "2.3125rem"
}));

export const CapabilitiesToggle = styled("button")(({ theme }) => ({
  alignItems: "center",
  background: "none",
  border: "none",
  color: theme.customColors.systemSecondary01,
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  fontFamily: "inherit",
  fontSize: "0.875rem",
  fontWeight: 700,
  gap: "0.5rem",
  padding: 0,
  textAlign: "left"
}));

export const CapabilitiesContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
  paddingTop: "1rem"
}));

export const CapabilitiesText = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.875rem",
  fontWeight: 400
}));

export const CapabilitiesList = styled("ol")(({ theme }) => ({
  color: theme.customColors.textPrimary,
  display: "flex",
  flexDirection: "column",
  fontSize: "0.875rem",
  gap: "0.25rem",
  margin: 0,
  paddingLeft: "1.5rem"
}));

export const CapabilitiesListItem = styled("li")(() => ({
  fontSize: "0.875rem",
  fontWeight: 400
}));
